import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

    $scope.openWorkerChatModal = (size) => {
      $scope.settings.meseRiferimento = $scope.months[$scope.settings.meseRiferimentoId];
      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'WorkerDocumentiDoganaliEmessiModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: $scope.settings
        }
      });
    };

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.anagraficaMittenteIsNew = true;
    $scope.anagraficaDestinatarioIsNew = true;
    $scope.anagraficaProduttoreIsNew = true;
    $scope.anagraficaRegistranteIsNew = true;

    // $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    // $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.mittente = {};
    $scope.destinatario = {};
    $scope.produttore = {};
    $scope.registrante = {};
    $scope.PIVAType = new RegExp('(^[0-9]{11}$)|ND');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{16}$');
    let isDenominazioneMittenteDisabled;
    let isMittenteCFDisabled;
    let isMittentePIVADisabled;

    let isDenominazioneDestinatarioDisabled;
    let isDestinatarioCFDisabled;
    let isDestinatarioPIVADisabled;

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    $scope.saveAnagrafica = async () => {
      let anagraficaMittente = {
        email_pec: '',
        emails: [],
        company_name: $scope.settings.mittenteDenominazione,
        fiscal_code: $scope.settings.mittenteCodiceFiscale,
        piva: $scope.settings.mittentePiva,
      };
      let anagraficaDestinatario = {
        email_pec: '',
        emails: [],
        company_name: $scope.settings.destinatarioDenominazione,
        //fiscal_code: $scope.settings.destinatarioCodiceFiscale,
        piva: $scope.settings.destinatarioPiva,
      };

      const anagrafiche = [];
      if ($scope.anagraficaMittenteIsNew) {
        anagrafiche.push(anagraficaMittente);
      }
      if ($scope.anagraficaDestinatarioIsNew) {
        anagrafiche.push(anagraficaDestinatario);
      }
      const results = [];
      for (const anagrafica of anagrafiche) {
        try {
          await ArchiSmallServices.insertAnagrafica(anagrafica);
          results.push(true);
        } catch (err) {
          if (err.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', err);
          }
          results.push(false);
        }
      }
      return new Promise((resolve, reject) => {
        if (results.every(v => v) || results.length == 0) {
          resolve(true);
        }
        reject(false);
      });
    };

    $rootScope.formsubmitted = false;

    $scope.setConservazioneSettings = () => {
      $scope.settings.mittenteDenominazione = $scope.mittente.anagrafica;

      $scope.settings.destinatarioDenominazione = $scope.destinatario.anagrafica;

      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

            $scope.mittente.anagrafica = $scope.settings.mittenteDenominazione;
            isDenominazioneMittenteDisabled = $scope.settings.mittenteDenominazione !== '' && $scope.settings.mittenteDenominazione !== undefined;
            isMittenteCFDisabled = $scope.settings.mittenteCodiceFiscale !== '' && $scope.settings.mittenteCodiceFiscale !== undefined;
            isMittentePIVADisabled = $scope.settings.mittentePiva !== '' && $scope.settings.mittentePiva !== undefined;

            $scope.destinatario.anagrafica = $scope.settings.destinatarioDenominazione;
            isDenominazioneDestinatarioDisabled = $scope.settings.destinatarioDenominazione !== '' && $scope.settings.destinatarioDenominazione !== undefined;
            isDestinatarioCFDisabled = $scope.settings.destinatarioCodiceFiscale !== '' && $scope.settings.destinatarioCodiceFiscale !== undefined;
            isDestinatarioPIVADisabled = $scope.settings.destinatarioPiva !== '' && $scope.settings.destinatarioPiva !== undefined;
          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;

        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item, tipo: string) => {
      if (item !== undefined && typeof item === 'object') {
        if (tipo === 'mittente') {
          if (item._id === -1) {
            $scope.settings.mittenteDenominazione = '';
            $scope.settings.mittentePiva = '';
            $scope.settings.mittenteCodiceFiscale = '';
            isDenominazioneMittenteDisabled = false;
            isMittenteCFDisabled = false;
            isMittentePIVADisabled = false;
            $scope.anagraficaMittenteIsNew = true;
          } else {
            $scope.settings.mittenteDenominazione = item.company_name;
            $scope.settings.mittentePiva = item.piva;
            $scope.settings.mittenteCodiceFiscale = item.fiscal_code;
            isDenominazioneMittenteDisabled = item.company_name !== '' && item.company_name !== undefined;
            isMittenteCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isMittentePIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaMittenteIsNew = false;
          }
        }
        if (tipo === 'destinatario') {
          if (item._id === -1) {
            $scope.settings.destinatarioDenominazione = '';
            $scope.settings.destinatarioPiva = '';
            $scope.settings.destinatarioCodiceFiscale = '';
            isDenominazioneDestinatarioDisabled = false;
            isDestinatarioCFDisabled = false;
            isDestinatarioPIVADisabled = false;
            $scope.anagraficaDestinatarioIsNew = true;
          } else {
            $scope.settings.destinatarioDenominazione = item.company_name;
            $scope.settings.destinatarioPiva = item.piva;
            $scope.settings.destinatarioCodiceFiscale = item.fiscal_code;
            isDenominazioneDestinatarioDisabled = item.company_name !== '' && item.company_name !== undefined;
            isDestinatarioCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isDestinatarioPIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaDestinatarioIsNew = false;
          }
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);
      if ($select.ngModel.$name === 'mittente') {
        $scope.mittente.anagrafica = '';
        $scope.settings.mittentePiva = '';
        $scope.settings.mittenteCodiceFiscale = '';
        isMittenteCFDisabled = false;
        isMittentePIVADisabled = false;
        $scope.anagraficaMittenteIsNew = false;
      }
      if ($select.ngModel.$name === 'destinatario') {
        $scope.destinatario.anagrafica = '';
        $scope.settings.destinatarioPiva = '';
        $scope.settings.destinatarioCodiceFiscale = '';
        isDestinatarioCFDisabled = false;
        isDestinatarioPIVADisabled = false;
        $scope.anagraficaDestinatarioIsNew = false;
      }
    };

    $scope.isDenominazioneMittenteDisabled = () => {
      return isDenominazioneMittenteDisabled;
    };
    $scope.isMittenteCFDisabled = () => {
      return isMittenteCFDisabled;
    };
    $scope.isMittentePIVADisabled = () => {
      return isMittentePIVADisabled;
    };

    $scope.isDenominazioneDestinatarioDisabled = () => {
      return isDenominazioneDestinatarioDisabled;
    };
    $scope.isDestinatarioCFDisabled = () => {
      return isDestinatarioCFDisabled;
    };
    $scope.isDestinatarioPIVADisabled = () => {
      return isDestinatarioPIVADisabled;
    };

    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.dpOpened = {
      dataDocumento: false,
    };

    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };


    $scope.openWorkerModal = async (size) => {

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

      try {
        await $scope.saveAnagrafica();
      } catch (err) {
        return;
      }

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerDocumentiDoganaliEmessiModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };
    // </editor-fold>

  }
}


export const ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-documenti-doganali-emessi-step2.html'),
  controller: ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-documenti-doganali-emessi-step2/conservazione-carica-documento-documenti-doganali-emessi-step2.ts